import { Component, inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AddRessourceComponent } from './add-ressource/add-ressource.component';
import { GenericStreamsService } from '../../service/generic-streams.service';

@Component({
    selector: 'app-figma-exports',
    standalone: false,
    templateUrl: './figma-exports.component.html',
    styleUrl: './figma-exports.component.scss',
})
export class FigmaExportsComponent implements OnInit {
    dialog = inject(MatDialog);
    genService = inject(GenericStreamsService);
    projectList: any[] = [];
    isLoading: boolean = false;

    async ngOnInit(): Promise<void> {
        this.isLoading = true;
        let data = await this.genService.getFigmaSiteExports();
        this.isLoading = false;
        if (data === false) {
            return;
        }
        this.projectList = data as any[];
    }

    async deleteFigmaExport(id: string) {
        const i = confirm('Are you sure you want to delete this export?');
        if (!i) {
            return;
        }
        const result = await this.genService.deleteFigmaExport(id);
        if (result === false) {
            return;
        }
        this.projectList = this.projectList.filter((p) => p.id !== id);
    }

    addressource() {
        let dia = this.dialog.open(AddRessourceComponent, {
            panelClass: 'small-dialog',
            autoFocus: false,
        });

        dia.afterClosed().subscribe(async () => {
            this.isLoading = true;
            let data = await this.genService.getFigmaSiteExports();
            this.isLoading = false;
            if (data === false) {
                return;
            }
            this.projectList = data as any[];
        });
    }
    open(url: string) {
        window.open(url, '_blank');
    }

    async deleteExport(id: string) {
        const i = confirm("Are you sure you want to delete this export?");
        if (i) {
            this.isLoading = true;
            let result = await this.genService.deleteFigmaSiteExports(id);
            this.isLoading = false;
            if (result === false) {
                return;
            }
            // Update project list
            this.isLoading = true;
            let data = await this.genService.getFigmaSiteExports();
            this.isLoading = false;
            if (data === false) {
                return;
            }
            this.projectList = data as any[];
        }
    }
    async reload(id: string) {
        let project = this.projectList.find((p) => p.id === id);
        if (!project) {
            return;
        }
        let name = project.name;
        let url = project.url;
        this.isLoading = true;
        let result = await this.genService.updateFigmaSiteExports(
            id,
            name,
            url,
        );
        this.isLoading = false;
        if (result === false) {
            return;
        }
        // Update project list
        this.isLoading = true;
        let data = await this.genService.getFigmaSiteExports();
        this.isLoading = false;
        if (data === false) {
            return;
        }
        this.projectList = data as any[];
    }
}
